import styled from 'styled-components'

export const BlogEmailSubscriptionBlock = styled.div`
  height: 301px;
  width: 100%;
  max-width: 70vw;
  background: ${props => (props.withBackground ? '#FFD0D0' : '#ffffff')};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 36px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  @media (max-width: 1150px) {
    max-width: 100%;
  }
`

export const EmailSubscriptionForm = styled.form`
  width: 100%;
  max-width: 350px;
  text-align: center;
`

export const BlogEmailLabel = styled.p`
  font-weight: bold;
  font-size: 22px;
  line-height: 1.4;
  color: #000000;
  margin-top: 0;

  ${props =>
    props.horizontal &&
    `
    @media (min-width: 768px) {
      flex: 1;
      margin-bottom: 0;
    }
  `}

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const BlogEmailInput = styled.input`
  background: #ffffff;
  border: none;
  padding: 14px;
  width: 100%;
  font-size: 16px;
  letter-spacing: 0.01em;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  text-align: center;

  ${props =>
    props.horizontal &&
    `
    @media (min-width: 768px) {
      flex: 1.1;
      text-align: left;
    }
  `}
`

export const BlogEmailSubscribeButton = styled.input`
  background: #ff5e6d;
  border: none;
  border-radius: 93px;
  padding: 12px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.01em;
  color: white;
  width: 180px;
  height: 44px;
  box-sizing: border-box;
  margin-top: ${props => (props.horizontal ? '0px' : '14px')};
  cursor: pointer;
  margin-top: 20px;
  background: linear-gradient(
    270deg,
    #ff9d74 0%,
    #ff5e6d 37.4%,
    #ff4f7e 74.69%,
    #ff6d90 100%
  );

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)),
      linear-gradient(
        270deg,
        #ff9d74 0%,
        #ff5e6d 37.4%,
        #ff4f7e 74.69%,
        #ff6d90 100%
      );
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 40px;
    padding: 0;
  }

  ${props =>
    props.horizontal &&
    `
    @media (min-width: 768px) {
      margin-top: 0;
      flex: 0.4;
      margin-left: 31px;
    }
  `}
`
